import { VUE_APP_DEPLOY_REGION } from '../config'
import { useLocale } from './useLocale'

export function useDomainCtx() {
  const { locale } = useLocale()
  return {
    locale: locale.value,
    region: VUE_APP_DEPLOY_REGION,
  }
}
